class FBTWidget extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('.fbt-checkbox');
    this.totalPriceEl = this.querySelector('#fbt-total-price');
    this.addBtn = this.querySelector('#fbt-add-btn');

    this.bindEvents();
    this.updateTotal();
  }

  bindEvents() {
    this.checkboxes.forEach(cb => {
      cb.addEventListener('change', () => this.updateTotal());
    });

    this.addBtn.addEventListener('click', () => this.addToCart());
  }

  updateTotal() {
    let total = 0;
    let selectedCount = 0;
    this.checkboxes.forEach(cb => {
      if (cb.checked) {
        total += parseInt(cb.dataset.price);
        selectedCount++;
      }
    });

    // Simple money formatting (assuming INR or matching store format loosely)
    // Shopify prices are in cents/paise
    const formattedTotal = 'Rs. ' + (total / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
    this.totalPriceEl.textContent = formattedTotal;

    this.addBtn.disabled = selectedCount === 0;
  }

  addToCart() {
    const items = [];
    this.checkboxes.forEach(cb => {
      if (cb.checked) {
        items.push({
          id: cb.dataset.variantId,
          quantity: 1
        });
      }
    });

    if (items.length === 0) return;

    this.addBtn.textContent = 'Adding...';
    this.addBtn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      // Redirect to cart page after adding multiple items
      window.location.href = window.Shopify.routes.root + 'cart';
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      this.addBtn.disabled = false;
    });
  }
}

customElements.define('fbt-widget', FBTWidget);
